import React from 'react';
import styled from '@emotion/styled';

import { DocumentPath } from '../../../types';
import { ImageMapLinkEditor } from '../ImageMapLink/ImageMapLinkEditor';
import { ImageMapShareButton, ImageMapShareButtonProps } from './ImageMapShareButton';

export interface ImageMapShareProps extends ImageMapShareButtonProps {
  path: DocumentPath;
}

export function ImageMapShare({
  children,
  path,
  ...rest
}: React.PropsWithChildren<ImageMapShareProps>) {
  return (
    <ImageMapLinkEditor path={path}>
      <StyledButton {...rest}>
        { children || '' }
      </StyledButton>
    </ImageMapLinkEditor>
  );
}

const StyledButton = styled(ImageMapShareButton)`
  position: absolute;
`;
